import { render } from "./table.vue?vue&type=template&id=7773669b&scoped=true&ts=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"

import "./table.vue?vue&type=style&index=0&id=7773669b&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7773669b"]])

export default __exports__